let appWindow: any = window;
const appConstants = {
  apiUrl:
    appWindow?.bfdlConfig?.apiUrl ||
    "https://library.battleface.com/wp-json/wp/v2",
  webappBaseUrl: appWindow?.bfdlConfig?.webappBaseUrl || "",
};

export default appConstants;
